import React from 'react'
import './Blog_Card.css'
import { useNavigate } from 'react-router-dom'

const Blog_Card = ({ link, img, blogTitle }) => {

  const navigate = useNavigate()

  return (
    <div className='Blog_Card' onClick={() => { navigate(link) }}>
      <div className='bg_coloured_div'></div>
      <div className='main_card'>
        <div className='img_holder'>
          <img src={img} className='blog_img' />
        </div>
        <div className='bottom_div'>
          <p className='blog_title'>{blogTitle}</p>
        </div>
      </div>
    </div>
  )
}

export default Blog_Card
